<template>
  <v-responsive
    :aspect-ratio="aspectRatio"
    class="terminus-section-header align-center"
  >
    <div class="terminus-section-header__text-group" :aria-label="name">
      <div class="terminus-section-header__text-for-width" aria-hidden>
        {{ name }}
      </div>
      <div
        class="terminus-section-header__text"
        :class="{
          'terminus-section-header__text-outlined': iOutlineds.includes(index),
          'terminus-section-header__text-revealed': isRevealed(index)
        }"
        :style="justifiedStyle()"
        v-for="index in 7"
        :key="index"
        :ref="`textline-${index}`"
        aria-hidden
      >
        {{ name }}
      </div>
    </div>
  </v-responsive>
</template>
<script>
export default {
  props: {
    name: String,
    alt: String
  },
  data: function() {
    return {
      iOutlineds: [1, 3, 4, 5],
      iRevealed: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onScroll);
    this.onScroll();
  },
  methods: {
    isRevealed(i) {
      return i <= this.iRevealed;
    },
    justifiedStyle() {
      return {
        "letter-spacing": `${this.letterSpacing}em`,
        "margin-right": `-${this.letterSpacing}em`
      };
    },
    onScroll() {
      this.iRevealed = 0;
      Object.keys(this.$refs).forEach((k, i) => {
        if (
          this.$refs[k][0].getBoundingClientRect().y <
          window.innerHeight * 0.65
        ) {
          this.iRevealed = i + 1;
        }
      });
    }
  },
  computed: {
    aspectRatio() {
      const aspectRatio = {
        sm: 375 / 308,
        xs: 375 / 308
      };

      return aspectRatio[this.$size] || 1439 / 516;
    },
    letterSpacing() {
      return 1.628 / (this.name.length - 1);
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
  }
};
</script>

<style lang="scss" scoped>
.terminus-section-header {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  // background-image: url("~@/assets/header-bg.png");
  .v-responsive__content {
    align-items: center;
  }
  @media screen and (max-width: 960px) {
    // background-image: url("~@/assets/header-bg-mobile.png");
  }

  &__text-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 39%;
    @media screen and (max-width: 960px) {
      width: 75%;
    }
  }

  &__text,
  &__text-for-width {
    font-size: 5.97vw;
    @media screen and (max-width: 960px) {
      font-size: 11.169vw;
    }
    font-weight: 300;
    text-transform: uppercase;
  }
  &__text-for-width {
    position: absolute;
    visibility: hidden;
  }

  &__text {
    line-height: 1;
    height: 0.5em;
    overflow: hidden;
    color: $cmf-darkgrey;

    &:last-child {
      height: 1em;
    }

    @supports (-webkit-text-stroke: 0.02326em $cmf-darkgrey) {
      &-outlined {
        color: transparent;
        -webkit-text-stroke: 0.02326em $cmf-darkgrey;
        -webkit-text-fill-color: transparent;
      }
    }

    visibility: hidden;
    &-revealed {
      visibility: visible;
    }
  }

  &__text-img {
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: 39%;
    @media screen and (max-width: 960px) {
      background-size: 75%;
    }
  }
}
</style>
